// WooCommerce REST API 的基礎路徑
export const WOO_REST_API_PATH = "/wp-json/wc";
// 用於代理的 WooCommerce REST API 路徑
export const WOO_REST_API_PATH_PROXY = "/api/rest";

export const WOO_CUSTOM_API_PATH = "/wp-json/wc/custom";
export const WOO_CUSTOM_API_PATH_PROXY = "/api/custom";

export const WP_TOTAL_HEADER_KEY = "x-wp-total";

export const RELEASE_VERSION = "1.3.3260121"; // 發版需手動更新

export const VITE_MODES = {
  LOCAL: "development.local",
  DEVELOPMENT: "development",
  PRODUCTION: "production",
};
